import React, { useEffect, useRef, useState } from "react";

import "./style.css";

const Landing = ({ data }) => {
  const [visibleSections, setVisibleSections] = useState(
    Array(data?.length).fill(false)
  );
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.index;
          setVisibleSections((prev) => {
            const updated = [...prev];
            updated[index] = entry.isIntersecting; // Set visibility based on intersection state
            return updated;
          });
        });
      },
      { threshold: 0.5, rootMargin: "0px 0px -20% 0px" } // rootMargin to adjust visibility trigger
    );

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionRefs.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  return data?.map(({ title, description, image }, index) => (
    <div
      className={`hidden lg:flex scroll-section  w-full relative text-font  transition-all duration-500 overflow-hidden`}
      key={index}
      data-index={index}
      ref={(el) => (sectionRefs.current[index] = el)}
    >
      <div
        style={{ backgroundImage: `url(${image})` }}
        className={`absolute top-1/2 -translate-y-1/2 w-full h-full services-bg ${
          index % 2 === 0 ? "left-0" : "order-2 ml-auto"
        }`}
      >
        <div
          className={`absolute bg-black opacity-80  mix-blend-multiply w-3/4 h-full  transition ease-in duration-1000 ${
            index % 2 === 0 ? "left-0" : "right-0 ml-auto"
          } ${
            visibleSections[index]
              ? "translate-y-[-100%] opacity-0 "
              : "translate-y-[0%] opacity-100"
          } `}
        ></div>
      </div>
      <div
        className={`w-[55%] h-full relative px-24  flex flex-col  justify-center   transition ease-in duration-700 ${
          index % 2 === 0 ? "ml-auto" : ""
        }  ${
          visibleSections[index] && index % 2 === 0
            ? "opacity-100  scale-[1] "
            : "opacity-0  scale-[0.6]"
        } ${
          visibleSections[index] && index % 2 !== 0
            ? "opacity-100 scale-[1] "
            : "opacity-0  scale-[0.6]"
        }`}
      >
        <h3 className="bebas text-5xl xxl:text-6xl">{title}</h3>
        <p className="text-white text-lg w-[80%] mt-2 leading-[1.6]">
          {description}
        </p>
      </div>
    </div>
  ));
  // return data?.map(({ title, description, image }, index) => (
  //   <div
  //     className={`hidden lg:flex scroll-section  w-full relative text-font  transition-all duration-500 overflow-hidden`}
  //     key={index}
  //     data-index={index}
  //     ref={(el) => (sectionRefs.current[index] = el)}
  //   >
  //     <div
  //       style={{ backgroundImage: `url(${image})` }}
  //       className={`absolute top-1/2 -translate-y-1/2 w-full h-full services-bg ${
  //         index % 2 === 0 ? "left-0" : "order-2 ml-auto"
  //       }`}
  //     >
  //       <div
  //         className={`absolute bg-black opacity-80  mix-blend-multiply w-3/4 h-full  transition ease-in duration-1000 ${
  //           index % 2 === 0 ? "left-0" : "right-0 ml-auto"
  //         } ${
  //           visibleSections[index]
  //             ? "translate-y-[-100%] opacity-0 "
  //             : "translate-y-[0%] opacity-100"
  //         } `}
  //       ></div>
  //     </div>
  //     <div
  //       className={`w-[55%] h-full relative px-24  flex flex-col  justify-center   transition ease-in duration-700 ${
  //         index % 2 === 0 ? "ml-auto" : ""
  //       }  ${
  //         visibleSections[index] && index % 2 === 0
  //           ? "opacity-100  scale-[1] "
  //           : "opacity-0  scale-[0.6]"
  //       } ${
  //         visibleSections[index] && index % 2 !== 0
  //           ? "opacity-100 scale-[1] "
  //           : "opacity-0  scale-[0.6]"
  //       }`}
  //     >
  //       <h3 className="bebas text-5xl xxl:text-6xl">{title}</h3>
  //       <p className="text-white text-lg w-[80%] mt-2 leading-[1.6]">
  //         {description}
  //       </p>
  //     </div>
  //   </div>
  // ));
};

export default Landing;
